// extracted by mini-css-extract-plugin
export default {"wrap":"Input_wrap__Qq8eG"};